module.exports = "/_next/static/images/mandy-nicole@2x-fbb1f0b7b2fb2c308bc42fbeeb1917af.png";